import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import type { CandidateCreator } from '@/types/candidates';
import { formatDistanceToNow } from 'date-fns';

interface CandidateRecruiterCardProps {
  creator: CandidateCreator | null;
  createdAt: string;
}

export function CandidateRecruiterCard({ creator, createdAt }: CandidateRecruiterCardProps) {
  const fullName = creator ? `${creator.firstName} ${creator.lastName}`.trim() : 'System';
  const initials = creator
    ? `${creator.firstName[0] ?? ''}${creator.lastName[0] ?? ''}`.toUpperCase() || '?'
    : 'S';

  return (
    <section className="rounded-lg border border-border bg-background p-5">
      <h2 className="mb-3 text-base font-medium">Added by</h2>
      <div className="flex items-center gap-3">
        <Avatar className="h-10 w-10 shrink-0 rounded-full">
          {creator?.avatarUrl ? <AvatarImage src={creator.avatarUrl} alt={fullName} /> : null}
          <AvatarFallback className="rounded-full text-sm">{initials}</AvatarFallback>
        </Avatar>
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-foreground" title={fullName}>
            {fullName}
          </p>
          <p className="text-xs text-muted-foreground">
            {formatDistanceToNow(new Date(createdAt), { addSuffix: true })}
          </p>
        </div>
      </div>
    </section>
  );
}
